import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "../pages/dashboard";
import Login from "../pages/login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProtectedRoutes from "./private";
import Banners from "../pages/banners";
import Projects from "../pages/projects";
import JobRequest from "../pages/job-requests";
import UserReport from "../pages/user-report";
import JobOpenings from "../pages/job-openings";

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <ToastContainer />
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route element={<ProtectedRoutes />}>
        <Route path="/" element={<Banners />} />
        {/* <Route path="/banners" element={<Banners />} /> */}
        <Route path="/projects" element={<Projects />} />
        <Route path="/job-request" element={<JobRequest />} />
        <Route path="/job-openings" element={<JobOpenings />} />
        <Route path="/user-report" element={<UserReport />} />

        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
